import React from 'react';
import logoMh from '../../assets/logo_mh.png';

import './styles.css';

const Topbar: React.FC = () => (
  <div className='mh-topbar'>
    <img src={logoMh} alt='microhouse' />
  </div>
);

export default Topbar;
